/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Integration_Status_Not_ConnectedInputs */

const en_ui_integration_status_not_connected = /** @type {(inputs: Ui_Integration_Status_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not connected`)
};

const de_ui_integration_status_not_connected = /** @type {(inputs: Ui_Integration_Status_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht verbunden`)
};

/**
* | output |
* | --- |
* | "Not connected" |
*
* @param {Ui_Integration_Status_Not_ConnectedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_integration_status_not_connected = /** @type {((inputs?: Ui_Integration_Status_Not_ConnectedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Integration_Status_Not_ConnectedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_integration_status_not_connected(inputs)
	return de_ui_integration_status_not_connected(inputs)
});